import httpClient from './httpClient'

export default {
  async getSessions() {
    let ret = await httpClient.get('/session')
    return ret
  },

  async removeSession(sessionId) {
    let ret = await httpClient.delete(`/session/${sessionId}`)
    return ret
  },
}
